import { Injectable, Output, EventEmitter } from "@angular/core";
import { GenericLayerService } from "src/app/services/generic-layer.service";
import { Observable } from "rxjs";
import { isNumeric } from "rxjs/internal-compatibility";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { ILayerSelections } from "../interface/selectedSet";

@Injectable({
  providedIn: "root"
})
export class GenericMapMethodsService {
  public childLayerObj;

  public map;
  public Draw;
  private Measure;
  public Query;
  public FeatureLayer;
  public GraphicsLayer;
  private ArcGISDynamicMapServiceLayer;
  private BasemapGallery;
  private LocateButton;
  public Extent;
  private OverviewMap;
  private SearchWidget;
  private InfoTemplate;
  private Color;
  private SimpleLineSymbol;
  private SimpleMarkerSymbol;
  private SimpleFillSymbol;
  private TextSymbol;
  private Font;
  ////private Legend;
  public Graphic;
  private Circle;
  private Units;
  public Point;
  private Locator;
  private ColorPicker;
  private webMercatorUtils;
  private PictureMarkerSymbol;
  private PopupTemplate;
  private Popup;
  private domConstruct;
  private registry;
  private VectorTileLayer;
  private ScreenPoint;
  private PopupExtended;
  private RelationshipQuery;
  private AttributeInspector;
  private FeatureTable;
  private Edit;
  private scaleUtils;
  private request;
  private QueryTask;
  private Polyline;
  private Polygon;
  public all;
  private SimpleRenderer;
  private TimeInfo;
  private TimeSlider;
  private TimeExtent;
  private Geoprocessor;
  private geometryEngine;
  private mathUtils;
  private event;
  private geometryJsonUtils;
  public graphicsUtils;
  // Added By Madhuri JIRA ID :- 62
  public queryBuilderZoomExtent = false;
  public esriBundle;
  // userdefined data ;
  selectedOpentasksJSON;
  selectionGraphicsLyr;
  selectedSet: ILayerSelections[];
  @Output() public emitSelectedGraphicsOnMap: EventEmitter<any> = new EventEmitter();
  clickEventOnGraphics;
  public relocateChild = false;
  public relocateChildAsset;
  public currentUser;
  private ftrLyrTblMaintenance;
  private ftrLyrActivity;
  private selectedLayer;
  private rollbackData;
  //TSDRSAM-975By Manikantha
  public linearAssetSelectionColor;
  public linearAssetSelectionWidth = 4;
  public linearAssetRelocateWidth = 6;
  public linearAssetEditColor;



  // Added by Manikantha for JIRA ID:-34
  ftrLyrSign;
  signTypes;
  ftrLyrLight;
  lightTypes; //1546

  constructor(private genericLayerService: GenericLayerService, private translateService: TranslateService) {
    this.childLayerObj = [];
  }
  setEsriModules(
    Map: any,
    Draw: any,
    Measurement: any,
    Query: any,
    FeatureLayer: any,
    GraphicsLayer: any,
    ArcGISDynamicMapServiceLayer: any,
    BasemapGallery: any,
    LocateButton: any,
    Extent: any,
    OverviewMap: any,
    Search: any,
    InfoTemplate: any,
    Color: any,
    SimpleLineSymbol: any,
    SimpleMarkerSymbol: any,
    SimpleFillSymbol: any,
    TextSymbol: any,
    Font: any,
    ////Legend: any,
    Graphic: any,
    Circle: any,
    Units: any,
    Point: any,
    Locator: any,
    ColorPicker: any,
    webMercatorUtils: any,
    PictureMarkerSymbol: any,
    PopupTemplate: any,
    Popup: any,
    domConstruct: any,
    registry: any,
    VectorTileLayer: any,
    ScreenPoint: any,
    PopupExtended: any,
    RelationshipQuery: any,
    AttributeInspector: any,
    FeatureTable: any,
    Edit: any,
    scaleUtils: any,
    request: any,
    QueryTask: any,
    Polyline: any,
    Polygon: any,
    all: any,
    SimpleRenderer: any,
    TimeInfo: any,
    TimeSlider: any,
    TimeExtent: any,
    Geoprocessor: any,
    geometryEngine: any,
    mathUtils: any,
    event: any,
    geometryJsonUtils,
    graphicsUtils: any,
    esriBundle: any
  ): void {
    this.map = Map;
    this.Draw = Draw;
    this.Measure = Measurement;
    this.Query = Query;
    this.FeatureLayer = FeatureLayer;
    this.GraphicsLayer = GraphicsLayer;
    this.ArcGISDynamicMapServiceLayer = ArcGISDynamicMapServiceLayer;
    this.BasemapGallery = BasemapGallery;
    this.LocateButton = LocateButton; // Locate
    this.Extent = Extent; // setExtent
    this.OverviewMap = OverviewMap; // InsetMap
    this.SearchWidget = Search; // Search Widget
    this.InfoTemplate = InfoTemplate; // Info template
    this.Color = Color;
    this.SimpleLineSymbol = SimpleLineSymbol;
    this.SimpleMarkerSymbol = SimpleMarkerSymbol;
    this.SimpleFillSymbol = SimpleFillSymbol;
    this.TextSymbol = TextSymbol;
    this.Font = Font;
    ////this.Legend = Legend;
    this.Graphic = Graphic;
    this.Circle = Circle;
    this.Units = Units;
    this.Point = Point;
    this.Locator = Locator;
    this.ColorPicker = ColorPicker;
    this.webMercatorUtils = webMercatorUtils;
    this.PictureMarkerSymbol = PictureMarkerSymbol;
    this.PopupTemplate = PopupTemplate;
    this.Popup = Popup;
    this.domConstruct = domConstruct;
    this.registry = registry;
    this.VectorTileLayer = VectorTileLayer;
    this.ScreenPoint = ScreenPoint;
    this.PopupExtended = PopupExtended;
    this.RelationshipQuery = RelationshipQuery;
    this.AttributeInspector = AttributeInspector;
    this.FeatureTable = FeatureTable;
    this.Edit = Edit;
    this.scaleUtils = scaleUtils;
    this.request = request;
    this.QueryTask = QueryTask;
    this.Polyline = Polyline;
    this.Polygon = Polygon;
    this.all = all;
    this.SimpleRenderer = SimpleRenderer;
    this.TimeInfo = TimeInfo;
    this.TimeSlider = TimeSlider;
    this.TimeExtent = TimeExtent;
    this.Geoprocessor = Geoprocessor;
    this.geometryEngine = geometryEngine;
    this.mathUtils = mathUtils;
    this.event = event;
    this.geometryJsonUtils = geometryJsonUtils;
    this.graphicsUtils = graphicsUtils;
    this.esriBundle = esriBundle;
    // this.assessmentlyr = new this.FeatureLayer(
    //   this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.assessmentId,
    //   { outFields: ["*"] }
    // );
    this.linearAssetSelectionColor = new this.Color([46, 46, 253, .7]);
    this.linearAssetEditColor = new this.Color([0, 245, 255, 1]);

    // Added by Manikantha for JIRA ID:-34
    if (this.currentUser && this.currentUser.tableIds && this.currentUser.tableIds.signId) {
      this.ftrLyrSign = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.signId, { outFields: ["*"] });
      this.ftrLyrSign.on(
        "Load",
        function (evt) {
          console.log(evt);
          if (this.ftrLyrSign.types) {
            this.signTypes = this.ftrLyrSign.types;
          }
        }.bind(this)
      );
    }
    //JIRA ID:-34-1546
    if (this.currentUser && this.currentUser.tableIds && this.currentUser.tableIds.lightId) {
      this.ftrLyrLight = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.lightId, { outFields: ["*"] });
      this.ftrLyrLight.on(
        "Load",
        function (evt) {
          console.log(evt);
          if (this.ftrLyrLight.types) {
            this.lightTypes = this.ftrLyrLight.types;
          }
        }.bind(this)
      );
    }
  }
  isVisualizationLayer(layerObject) {
    if ((layerObject.lyrObj != null && layerObject.lyrObj.url.includes(environment.apiBaseUrl)) || layerObject.type == "inventory") {
      return false;
    }
    return true;
  }



  showSelectedOnMap(selectedSet: ILayerSelections[]){
    // // get or initialize graphics layer for selection pins
    // if (this.map.getLayer("sms-selection")) {
    //   this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
    // } else {
    //   this.selectionGraphicsLyr = new this.GraphicsLayer({ id: "sms-selection" });
    //   this.map.addLayer(this.selectionGraphicsLyr);
    // }
    // this.selectionGraphicsLyr.clear();

    // this.enableMapGraphicClick(selectedSet);

    // selectedSet.forEach( (layerSelections) => {

    //   // add blue or orange pin at feature's location
    //   let geom;
    //   if (layerGeomType === "esriGeometryPolyline") {
    //     this.highlightLinearAssets(feature);
    //     geom = this.webMercatorUtils.webMercatorToGeographic(feature.geometry);
    //     if (geom.paths && geom.paths[0] && geom.paths[0][0]) {
    //       geom = this.getPolylineMidPoint(feature.geometry);
    //     }
    //   } else {
    //     geom = feature.geometry;
    //   }
    //   if (geom) {
    //     const locationHasOpenTasks = feature.attributes.opentasksobj?.length > 0 ? feature.attributes.opentasksobj[0].OpenTasks : false; // opentasksobj not added to features with no open tasks, including all VisualizationLayers. .OpenTasks: boolean true if any open task at location (parent or child). 
    //     const pin = locationHasOpenTasks ? pinHasTasks : pinHasNoTasks; 
    //     pin.setOffset(0, 5);
    //     const graphic = new this.Graphic(geom, pin);
    //     graphic.attributes = feature.attributes;
    //     this.selectionGraphicsLyr.add(graphic);
    //   }

    // }

  }


  getOpenTasks(selectedSet: ILayerSelections[], activeLayerIndex: number, activeParentIndex: number): void {
    // selectedSet includes an array of ILayerSelections, one for every layer (including visualization layers) with a currently selected asset.
    // this method retrieves open tasks for all selected assets and updates the map with corresponding selection pins.
    // data about any child assets of selected assets is also included in the response. This data is appended to the parent asset's attributes in the selectedSet.

    // get or initialize graphics layer for selection pins
    if (this.map.getLayer("sms-selection")) {
      this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
    } else {
      this.selectionGraphicsLyr = new this.GraphicsLayer({ id: "sms-selection" });
      this.map.addLayer(this.selectionGraphicsLyr);
    }
    this.selectionGraphicsLyr.clear();

    this.selectedOpentasksJSON = {};
    this.enableMapGraphicClick(selectedSet);

    // get open tasks for selected assets
    let assetIdsByLayer: { [key: string]: string[] } = {};
    selectedSet.forEach((layer) => {
      // group asset IDs by layerName for the API request  [{<layer name>: ["AssetId", "AssetId", ...]}, ...]
      //assetIdsByLayer[layer.LayerInfo.name] = layer.Data.map(f => f.attributes.AssetID).filter(id => id);  // added filter to skip any with no AssetID value
      assetIdsByLayer[layer.LayerInfo.name] = layer.Data.map(f => f.attributes.AssetID);  // without filter to skip any with no AssetID value
    });
    this.genericLayerService.getOpentasks(assetIdsByLayer).subscribe((opentasksRes: any) => {

      this.selectedOpentasksJSON = JSON.parse(opentasksRes);

      const pinHasNoTasks = new this.PictureMarkerSymbol("assets/images/marker_blue.png", 20, 20);
      const pinHasTasks = new this.PictureMarkerSymbol("assets/images/marker_orange.png", 20, 20);

      selectedSet.forEach((layerSelections) => {
        const layerName = layerSelections.LayerInfo.name;
        const layerGeomType = layerSelections.LayerInfo.lyrObj?.geometryType; // note that VisualizationLayers don't have lyrObj
        const layerOpenTasks = this.selectedOpentasksJSON.OpenTaskByAsset[0][layerName];

        layerSelections.Data.forEach((feature) => {

          if (layerOpenTasks?.length > 0) {
            // add open tasks-related attributes and data to feature's attributes
            // note: visualization layers will never have open tasks
            feature.attributes.opentasksobj = layerOpenTasks.find((taskInfo) => taskInfo.AssetId == feature.attributes.AssetID);
            feature.attributes.tasks = feature.attributes.opentasksobj?.OpenTaskCount ?? 0;
          }

          // add blue or orange pin at feature's location
          let geom;
          if (layerGeomType === "esriGeometryPolyline") {
            this.highlightLinearAssets(feature);
            geom = this.webMercatorUtils.webMercatorToGeographic(feature.geometry);
            if (geom.paths && geom.paths[0] && geom.paths[0][0]) {
              geom = this.getPolylineMidPoint(feature.geometry);
            }
          } else {
            geom = feature.geometry;
          }
          if (geom) {
            const locationHasOpenTasks = feature.attributes.opentasksobj?.OpenTasks ?? false; // OpenTasks = true if any open task at location (parent or child).  opentasksobj not added to VisualizationLayers or ?.  
            const pin = locationHasOpenTasks ? pinHasTasks : pinHasNoTasks; 
            pin.setOffset(0, 5);
            const graphic = new this.Graphic(geom, pin);
            graphic.attributes = feature.attributes;
            this.selectionGraphicsLyr.add(graphic);
          }

        });
      });
  //    this.afterQuerySetZoomLevel();
      this.selectActiveAssetOnMap(selectedSet[activeLayerIndex].Data[activeParentIndex], null);
    });
  }

  selectActiveAssetOnMap(asset, activeAssetInfo): void {
    //notes:  asset = value at selectedSet[i1].Data[i2], where i1 = eeService.selectedLayerIndexOnData and i2 = eeService.selectedParentIndexOnData
    //        activeAssetInfo may be null or the asset uber array, representing the active asset's feature data in the Asset Viewer.

    if (!asset) {
      // under what circumstances?
      return; 
    } else {
      let Layer = asset._layer;
      if (!Layer) {
        //skip for visualization layers
        // ???? do we not want to select active visualization layers?
        return;
      }
      if (!Layer.queryFeatures && activeAssetInfo && activeAssetInfo[1] && activeAssetInfo[1].lyrObj) {
        //what is the scenario where Layer does not have queryFeatures?
        Layer = activeAssetInfo[1].lyrObj;
      }

      let geometry;
      let image_url = "assets/images/marker_green.png";
      if (asset.attributes.opentasksobj?.OpenTasks > 0) {
        image_url = "assets/images/OpenSelectedMarker.png";
      }
      const width = 22;
      const height = 36;
      const picSym = new this.PictureMarkerSymbol(image_url, width, height);
      picSym.setOffset(0, 5);
      this.map.graphics.clear();

      if (asset.attributes.opentasksobj) {

        if (Layer.geometryType === "esriGeometryPolyline") {
          this.highlightLinearAssets(asset, true);
          geometry = this.getPolylineMidPoint(asset.geometry);
        } else {
          geometry = asset.geometry;
        }
        const graphic = new this.Graphic(geometry, picSym);
        graphic.attributes = asset.attributes;
        graphic.attributes.isActiveAsset = true; 
        this.map.graphics.add(graphic);

      } else {
        // asset has not had opentasks queried yet. 
        // Will this ever happen now that this method is called from getOpenTasks directly?
        const assetIdsByLayer = {};
        assetIdsByLayer[asset._layer._name] = [asset.attributes.AssetID];
        this.genericLayerService.getOpentasks(assetIdsByLayer).subscribe(
          (opentasksRes: any) => {
            this.selectedOpentasksJSON = JSON.parse(opentasksRes);

            // Collect opentask info for asset
            if (this.selectedOpentasksJSON.OpenTaskByAsset[0][asset._layer.name]) {
              asset.attributes.opentasksobj = this.selectedOpentasksJSON.OpenTaskByAsset[0][asset._layer.name].find((item) => item.AssetId == asset.attributes.AssetID);
              asset.attributes.tasks = asset.attributes.opentasksobj?.OpenTaskCount ?? 0;
            }

            // symbolize the active asset
            if (Layer.geometryType === "esriGeometryPolyline") {
              this.highlightLinearAssets(asset, true);
              geometry = this.getPolylineMidPoint(asset.geometry);
            } else {
              geometry = asset.geometry;
            }
            const graphic = new this.Graphic(geometry, picSym);
            graphic.attributes = asset.attributes;
            graphic.attributes.isActiveAsset = true; //Added for visualization layers.  what???
            this.map.graphics.add(graphic);
          }
        )
      }
    }
  }

  enableMapGraphicClick(selectedSet: ILayerSelections[]): void {
    this.selectedSet = selectedSet;
    if (this.clickEventOnGraphics) {
      this.clickEventOnGraphics.remove();
    }

    this.clickEventOnGraphics = this.selectionGraphicsLyr.on( "click", (evt) => {
        let assetIndex: number = -1;
        let layerIndex: number = -1;

        // find layer and asset indexes
        for (let i = 0; i < this.selectedSet.length; i++) {
          assetIndex = this.selectedSet[i].Data.findIndex((f) => f.attributes.AssetID === evt.graphic.attributes.AssetID);
          if (assetIndex >= 0) {
            layerIndex = i;
            break;
          }
        }
        
        if (this.relocateChild) {
          // TSDRSAM-1099 Manikantha V
          if (this.selectedSet[layerIndex]?.LayerInfo?.name == "Support") {
            this.moveToNewParent(evt.graphic.attributes.AssetID, layerIndex, assetIndex);
          } else {
            Swal.fire(this.translateService.instant("RelocateChild.selectSupport"));
            this.relocateChild = false;
          }
        } else {
          this.emitSelectedGraphicsOnMap.emit({layerIndex: layerIndex, assetIndex: assetIndex});
        }
      }
    );
  }

  // Added by Madhuri Gupta for JIRA ID:-62 on 08/03/2021
  afterQuerySetZoomLevel(): void {
    let extGraphics;
    let extGraphics1;
    let newExtent;
    if (this.selectionGraphicsLyr.graphics.length > 0) {
      const graphicarr = this.selectionGraphicsLyr.graphics.filter((ele) => {
        // Map Coordinate System WKID
        return ele.geometry.spatialReference.wkid == 4326;
      });
      const graphicarr1 = this.selectionGraphicsLyr.graphics.filter((ele) => {
        // Map Coordinate System WKID
        return ele.geometry.spatialReference.wkid == 102100;
      });
      if (graphicarr.length > 0) {
        extGraphics = this.webMercatorUtils.geographicToWebMercator(this.graphicsUtils.graphicsExtent(graphicarr));
      } else {
        extGraphics1 = this.graphicsUtils.graphicsExtent(graphicarr1);
      }
      if (extGraphics) {
        newExtent = extGraphics;
        if (extGraphics1) newExtent.union(extGraphics1);
      } else {
        newExtent = extGraphics1;
      }
      // For handleing point features
      if (newExtent != null) {
        if (newExtent.xmax == newExtent.xmin || newExtent.ymax == newExtent.ymin) {
          if (newExtent.xmax == newExtent.xmin) {
            newExtent.xmin = newExtent.xmin - 500;
            newExtent.xmax = newExtent.xmax + 500;
          }
          if (newExtent.ymax == newExtent.ymin) {
            newExtent.ymin = newExtent.ymin - 500;
            newExtent.ymax = newExtent.ymax + 500;
          }
          this.map.setExtent(newExtent, true);
        } else {
          newExtent.xmin -= 50;
          newExtent.xmax += 500;
          newExtent.ymin -= 500;
          newExtent.ymax += 150;
          this.map.setExtent(newExtent, true);
        }
      }
    }
  }

  getDetailedMaintenance(object) {
    const getMaintananceTasksObs = new Observable((observer) => {
      console.log("Observable starts");

      this.genericLayerService.getMaintananceTasks(object).subscribe((opentasksRes: any) => {
        observer.next(JSON.parse(opentasksRes));
      });
    });
    return getMaintananceTasksObs;
  }

  // TSDRSAM-975 By Manikantha
  highlightLinearAssets(asset: any, active: boolean = false): void {
    try {
      const highlightColor = active ? this.linearAssetEditColor : this.linearAssetSelectionColor;
      const lineSymbol = new this.SimpleLineSymbol({ color: highlightColor, width: this.linearAssetSelectionWidth });     
      const graphic = new this.Graphic(asset.geometry);
      if (asset._layer.name == "PavementMarking") { 
        lineSymbol.setStyle(this.SimpleLineSymbol.STYLE_DASH);
        graphic.graphictype = "dotline";
      } else {
        lineSymbol.setStyle(this.SimpleLineSymbol.STYLE_SOLID);
      }
      graphic.attributes = asset.attributes;
      graphic.setSymbol(lineSymbol);
      if (active) {
        //this.map.graphics.clear();
        this.map.graphics.add(graphic);
      } else {
        this.selectionGraphicsLyr.add(graphic);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // TSDRSAM-975 By Manikantha
  getPolylineMidPoint(polyline) {
    const path = polyline.paths[0];
    let length = 0;
    for (let i = 0; i < path.length - 1; i++) {
      const startPoint = polyline.getPoint(0, i);
      const nextPoint = polyline.getPoint(0, i + 1);
      //const d = this.geometryEngine.distance(startPoint, nextPoint, "feet");
      length += this.geometryEngine.distance(startPoint, nextPoint, "feet");
    }
    //const length = this.geometryEngine.geodesicLength(polyline, "feet"); // esri.geometry.geometryEngine
    const middleLength = length / 2;
    let currentDistance = 0;
    let beforeIndex = 0;
    let dt = 0;
    let dis = 0;
    let startPoint = polyline.getPoint(0, 0);
    for (let i = 1; i <= path.length - 1; i++) {
      const nextPoint = polyline.getPoint(0, i);
      const d = this.geometryEngine.distance(startPoint, nextPoint, "feet");
      if (currentDistance + d < middleLength) {
        currentDistance += d;
        startPoint = nextPoint;
      } else {
        dt = d + currentDistance - middleLength;
        dis = d;
        beforeIndex = i;
        break;
      }
    }
    const t = 1 - dt / dis;
    //startPoint = polyline.getPoint(0, beforeIndex);
    const endPoint = polyline.getPoint(0, beforeIndex);
    let x, y;
    if (isNumeric(t)) {
      x = (1 - t) * startPoint.x + t * endPoint.x; // (startPoint.x + endPoint.x) / 2
      y = (1 - t) * startPoint.y + t * endPoint.y; //(startPoint.y + endPoint.y) / 2;
    } else {
      x = (startPoint.x + endPoint.x) / 2;
      y = (startPoint.y + endPoint.y) / 2;
    }
    // const x = ((1 - t) * startPoint.x + t * endPoint.x);// (startPoint.x + endPoint.x) / 2
    // const y = ((1 - t) * startPoint.y + t * endPoint.y);//(startPoint.y + endPoint.y) / 2;
    // const midPoint =  (xt, yt) = (((1 - t) * x0 + t * x1), ((1 - t) * y0 + t * y1))
    const midPoint = new this.Point({ x, y, spatialReference: { wkid: polyline.spatialReference.wkid } }); // esri.geometry.Point
    return midPoint;
  }
  //  distanceBetweenPoints(x1, y1, x2, y2) {
  //   return Math.sqrt(Math.pow(x2 - x1, 2) + (Math.pow(y2 - y1, 2)));
  //  }

  //   getPointAlongLine(polyline, distance, pathIndex) {
  //   if (!pathIndex)
  //    pathIndex = 0;

  //   if (!distance)
  //    distance = 0;

  //   if ((pathIndex >= 0) && (pathIndex < polyline.paths.length)) {
  //    var path = polyline.paths[pathIndex];
  //    var x1, x2, x3, y1, y2, y3;
  //    var travelledDistance = 0;
  //    var pathDistance;
  //    var distanceDiff;
  //    var angle;

  //    if (distance === 0)
  //     return polyline.getPoint(pathIndex, 0);
  //    else if (distance > 0) {
  //     for (var i = 1; i < path.length; i++) {
  //      x1 = path[i-1][0];
  //      y1 = path[i-1][1];
  //      x2 = path[i][0];
  //      y2 = path[i][1];
  //  console.log(Math.sqrt(Math.pow(x2 - x1, 2) + (Math.pow(y2 - y1, 2))))
  //      pathDistance = this.distanceBetweenPoints(x1, y1, x2, y2);
  //      travelledDistance += pathDistance;

  //      if (travelledDistance === distance)
  //       return polyline.getPoint(pathIndex, i);
  //      else if (travelledDistance > distance) {
  //       distanceDiff = pathDistance - (travelledDistance - distance);

  //       angle = Math.atan2(y2-y1, x2-x1);

  //       x3 = distanceDiff * Math.cos(angle);
  //       y3 = distanceDiff * Math.sin(angle);

  //       return new this.Point(x1 + x3, y1 + y3, polyline.spatialReference);
  //      }
  //     }
  //    }
  //   }

  //   return null;
  //  }
  // TSDRSAM-1099 Manikantha V
  moveToNewParent(parentId, selectedLayer, index): void {
    //Swal.fire("abc");
    console.log("MOVING TO NEW PARENT");
    this.rollbackData = JSON.stringify(this.relocateChildAsset.attributes);
    Swal.fire({
      title: this.translateService.instant("RelocateChild.tittle"),
      text: this.translateService.instant("RelocateChild.text") + parentId + "?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translateService.instant("RelocateChild.save"),
      cancelButtonText: this.translateService.instant("RelocateChild.cancel")
    }).then((result) => {
      if (result.value) {
        this.relocateChild = false;
        console.log("yes");
        const asset = new this.Graphic();
        asset.setAttributes(this.relocateChildAsset.attributes);
        asset.attributes.ParentID = parentId;
        asset.ModifiedBy = this.currentUser.username;
        asset.LastModifyDate = new Date(Date.now()).getTime();
        const featureLayer = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.relocateChildAsset._layer.layerId, {
          outFields: ["*"]
        });
        featureLayer.applyEdits(null, [asset], null).then((editsResult) => {
          this.createRelocateTask(this.relocateChildAsset, selectedLayer, index);
          // this.emitSelectedGraphicsOnMap.emit([selectedLayer, index])
          console.log(editsResult);
        });
      } else {
        this.relocateChild = false;
      }
    });
  }
  // TSDRSAM-1099 Manikantha V
  createRelocateTask(asset, layerIndex: number, featureIndex: number) {
    //   this.selectedLayer = this.rowdataobj[this.eeService.selectedLayerIndexOnData].LayerInfo.layerName;
    this.ftrLyrTblMaintenance = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
    this.ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    const featurese = [];
    const features = new this.Graphic();
    const assetId = asset.attributes.AssetID;
    // const geomString = asset.geometry.toJson();
    // if (geomString.paths) {
    //   geomString.x = geomString.paths[0][0][0];
    //   geomString.y = geomString.paths[0][0][1];
    //   delete geomString.paths;
    // }
    let region;
    if (asset.attributes.Region4) {
      region = asset.attributes.Region4;
    } else if (asset.attributes.Region3) {
      region = asset.attributes.Region3;
    } else if (asset.attributes.Region2) {
      region = asset.attributes.Region2;
    } else if (asset.attributes.region) {
      region = asset.attributes.region;
    }
    const status = "Closed";
    const priorParentId = JSON.parse(this.rollbackData).ParentID;
    // TSDRSAM-1114 By Manikantha V
    features.setAttributes({
      Status: status,
      CreatedBy: this.currentUser.username,
      CreationDate: new Date(Date.now()).getTime(),
      CompletedBy: this.currentUser.username,
      CompletionDate: new Date(Date.now()).getTime(),
      Region: region,
      Reason: "Other",
      AssetID: assetId,
      AssetName: asset._layer._name,
      WorkOrderDesc: "",
      Comment: "Relocated from " + priorParentId,
      PendingChanges: JSON.stringify(this.generatePendingChangesForChildRelocate(priorParentId, asset.attributes.ParentID)),
      ModifiedBy: this.currentUser.username,
      LastModifyDate: new Date(Date.now()).getTime()
    });
    // GeomWKT: JSON.stringify(geomString),
    featurese.push(features);
    this.ftrLyrTblMaintenance
      .applyEdits(featurese, null, null)
      .then(
        function (newrow) {
          const featureseAssetID = [];
          const featuresA = new this.Graphic();
          featuresA.setAttributes({ OBJECTID: newrow[0].objectId, MaintID: "MNT_" + newrow[0].objectId });
          featureseAssetID.push(featuresA);
          this.ftrLyrTblMaintenance
            .applyEdits(null, featureseAssetID, null)
            .then(function () {
              console.log("sucess");
            })
            .catch((error) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
            });
          // End
          const actfeaturese = [];
          const actfeatures = new this.Graphic();
          actfeatures.setAttributes({
            MaintID: "MNT_" + newrow[0].objectId,
            Asset: this.assetTypeId,
            Activity: "Relocate",
            Description: " ",
            ModifiedBy: this.currentUser.username,
            LastModifyDate: new Date(Date.now()).getTime()
          });
          actfeaturese.push(actfeatures);
          this.ftrLyrActivity.applyEdits(actfeaturese, null, null).then(
            function () {
              // this.eeService.setreplaceTaskCreated(true);
              this.emitSelectedGraphicsOnMap.emit(layerIndex, featureIndex);
            }.bind(this)
          );
        }.bind(this)
      )
      .catch((error) => {
        console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
      });
  }

  public getBuffer(point, distance, units) {
    return this.geometryEngine.geodesicBuffer(point, distance, units);
  }

  public getGMLPointGeometry(coordinates) {
    let pointCoordinates = coordinates.split(" ")[0];
    let x = parseFloat(pointCoordinates.split(",")[0]);
    let y = parseFloat(pointCoordinates.split(",")[1]);
    let geometry = new this.Point({
      x: x,
      y: y,
      spatialReference: { wkid: 3857 }
    });
    return geometry;
  }

  public setActiveVisualizationAsset(geometry) {

    this.removePreviousActiveAsset();

    //add new active asset  
    const imgUrl = "assets/images/marker_green.png";
    //TODO: evaluate if this is the appropriate size or if it should match Managed Layer selected pin size.
    const imgWidth = 22;
    const imgHeight = 34.5;
    const imgPicSym = new this.PictureMarkerSymbol(imgUrl, imgWidth, imgHeight);
    let graphic = new this.Graphic(geometry, imgPicSym);
    graphic.attributes = [];                    /// don't want at least some attributes on the graphic? guess we can't know what attributes a wms layer will have
    graphic.attributes.isActiveAsset = true;
    this.map.graphics.add(graphic);
  }

  public removePreviousActiveAsset(): void {
    //remove previous active asset     Clean up symbology for previous active asset when switching between layers in selected set
    this.map.graphics.remove(this.map.graphics.graphics.find((g) => g.attributes?.isActiveAsset));
  }

  //TSDRSAM-1426
  generatePendingChangesForChildRelocate(priorParentId, toBeParentId) {
    let deltaResult = { before: { ParentID: {} }, after: { ParentID: {} } };

    deltaResult.before.ParentID = priorParentId;
    deltaResult.after.ParentID = toBeParentId;

    return deltaResult;
  }

  convertXYToLatLng(x: number, y: number): number{
    return this.webMercatorUtils.xyToLngLat(x, y);
  }

  disableDrawTool(): void{
    this.Draw.deactivate();
  }
}
